import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import Container from '@/ui/components/Container';
import Heading from '@/ui/components/Heading';
import PersonHeader from '@/ui/components/PersonHeader';

const Encounters = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const shouldDisplayBackButton = useMemo(() => !!location?.state?.headerName, [location]);
  const headerName = useMemo(() => location?.state?.headerName ?? 'Encounters', [location]);
  const personId = useMemo(() => location?.state?.person?.id ?? null, [location]);

  return (
    <>
      {shouldDisplayBackButton && personId ? (
        <PersonHeader person={location.state.person} />
      ) : (
        <div className="py-2 px-4 flex flex-row items-center bg-white">
          {shouldDisplayBackButton && (
            <button onClick={() => navigate(-1)}>
              <FontAwesomeIcon
                data-testid="back-icon"
                className="text-gray-900"
                icon={faChevronLeft}
              />
            </button>
          )}
          <div className="flex flex-1 flex-row items-center justify-center truncate">
            <Heading className="truncate" value={2} text={headerName} />
          </div>
        </div>
      )}

      <hr />
      <Container type="page">
        <Outlet />
      </Container>
    </>
  );
};

export default Encounters;
